(function ($) {
  // Utility Functions

  function findRepByZip(zip) {
    const zipUrl = `https://httpbin.org/get?&zip=${zip}`;
    $(".js-find-rep-info").html("");
    fetch(zipUrl)
      .then((res) => res.json())
      .then((data) => $(".js-find-rep-info").html("Success. Rep info to come."))
      .catch((err) => $(".js-find-rep-info").html(`error: ${err}`));
  }

  // Event Handlers
  function attachEventHandlers() {
    $(".js-find-rep-zip-btn").on("click", (e) => {
      e.stopPropagation();
      findRepByZip($(".js-find-rep-zip").val());
    });

    $(".js-get-location-btn").on("click", (e) => {
      e.stopPropagation();
      alert("todo: hook up to look up service.");
    });
  }

  // AOS Initialization
  function initializeAOS() {
    AOS.init({
      //startEvent: "DOMContentLoaded", // name of the event dispatched on the document, that AOS should initialize on
      //initClassName: "aos-init", // class applied after initialization
      //animatedClassName: "aos-animate", // class applied on animation
      //useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
      //disableMutationObserver: false, // disables automatic mutations' detections (advanced)
      //debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
      //throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)
      // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
      disable: () =>
        window.matchMedia("(prefers-reduced-motion: reduce)").matches ||
        "phone",
      offset: 120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 600, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: true, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });
  }

  // Page Initialization
  function initializePage() {
    attachEventHandlers();
    initializeAOS();
  }

  $(document).ready(initializePage);
})(jQuery);

var site = site || {};
site.Utility =  (function () {


    /**
     * Copy data to clipboard
     * @param {*} url 
    */
    var copyToClipboard = function(url) {
        navigator.clipboard.writeText(url).then(
            () => {
                console.log("Copied to clipboard: " + url);
                createSnackbar('Copied to clipboard!');
            },
            (err) => console.error("Could not copy text: ", err)
        );
    }



    /**
     * Force download a file - even if it's on another domain
     * @param {*} e 
    */
    var downloadFile = function (e) {
        e.preventDefault();

        let url = e.target.href != undefined ? e.target.href : e.target.parentElement.href;
        let name = decodeURI(getFileName(url).split(".")[0]);

        fetch(url, {
            headers: new Headers({
            Origin: location.origin,
            }),
            mode: "cors",
        })
            .then((response) => response.blob())
            .then((blob) => {
                let blobUrl = window.URL.createObjectURL(blob);
                    forceDownload(blobUrl, name);
                })
            .catch((e) => console.error(e));
    };

    var getFileName = function (link) {
        let splitLink = link?.split("/");
        return splitLink[splitLink.length - 1].slice(0, link.length);
    };

    var forceDownload = function (blob, filename) {
        var a = document.createElement("a");
        a.download = filename;
        a.href = blob;
        document.body.appendChild(a);
        a.click();
        a.remove();
    }



    /**
     * Create snackbar (toast)
     * https://www.w3schools.com/howto/howto_js_snackbar.asp
    */
    var createSnackbar = function(msg) {
        var snackbar = null;
        // Get the snackbar DIV
        if(document.getElementById("snackbar") == null) {
            snackbar = document.createElement("div");
            snackbar.setAttribute("id", "snackbar");
            document.body.appendChild(snackbar);
        } else {
            snackbar = document.getElementById("snackbar");
        }
      
        // Add the "show" class to DIV
        snackbar.className = "show";
        snackbar.innerHTML = msg;
      
        // After 3 seconds, remove the show class from DIV
        setTimeout(function(){ 
            snackbar.className = snackbar.className.replace("show", "");
            snackbar.innerHTML = '';
        }, 3000);
      }


return {
    copyToClipboard: copyToClipboard,
    createSnackbar: createSnackbar,
    downloadFile: downloadFile
}

}());
